<template>
    <div>
        <v-alert
            icon="mdi-file-document-outline"
            dense
            text
            type="info"
            v-if="data.can_carry && $can('all_permissions')"
            class="mb-2"
        >
            
            <v-row align="center" dense>
                <v-col class="grow">
                    Annual leave for this year expires on <b>{{$localeDate(data.last_annual_leave_history.dtToDate)}}</b>. You can request to carryforward to next year.
                </v-col>
                <v-col class="shrink">
                    <!-- <v-btn small @click="$refs.annualCarryforwardModal.open()">Apply</v-btn> -->
                    <v-btn x-small @click="$refs.staffFormsModal.open('annual_carryforward')">Apply</v-btn>
                </v-col>
            </v-row>
        </v-alert>

        <!-- <AnnualCarryforwardModal ref="annualCarryforwardModal" /> -->
        <StaffFormsModal ref="staffFormsModal" @reload="getItems()" />
    </div>
</template>

<script>
import axios from '../../plugins/axios'
// import AnnualCarryforwardModal from '../annual-carryforward/AnnualCarryforwardModal.vue'
import StaffFormsModal from '../staff-forms/StaffFormsModal.vue'

export default {
    // AnnualCarryforwardModal, 
    components: {StaffFormsModal},
    data: () => ({
        loading: false,
        data: {},
    }),
    methods: {
        getItems() {
            this.loading = true
            axios
                .get(`/api/manage-leaves/getCanCarryForwardLeaves`)
                .then((resp) => {
                    this.data = resp.data
                })
                .finally(() => (this.loading = false))
        },
    },
    mounted() {
        this.getItems()
    },
}
</script>

<style>
</style>